import React from 'react';
import CellAbstract from './CellAbstract';
import { CELL_REORDERING_ROWS_PROPS } from './Types';

export default class CellReorderingRows extends CellAbstract<CELL_REORDERING_ROWS_PROPS, {}> {
  render() {
    return this.renderCell(
      <span
        className={'tp-draggable-icon tp-icon tp-icon-md tp-handle tp-color-blue-500'}
        style={{ cursor: 'move' }}
        data-drag-handle={true}
      />
    );
  }
}
